import { useQuery } from "@apollo/client";
import { transformData } from "@crehana/utils";
import { AcademiesQueryDocument } from "../../../../Graphql/Queries/AcademiesQuery.v4.generated.js";
const useAcademiesQuery = ()=>{
    const { data, loading } = useQuery(AcademiesQueryDocument, {
        fetchPolicy: 'cache-first',
        context: {
            clientName: 'v4'
        }
    });
    let sortedBuckets = [
        ...data?.educationAcademies.buckets || []
    ];
    sortedBuckets = sortedBuckets.sort((a, b)=>{
        if (a?.id && b?.id) return b.id - a.id;
        return 0;
    });
    return {
        loading,
        buckets: sortedBuckets,
        academies: data?.educationAcademies ? transformData(data.educationAcademies) : []
    };
};
const hooks_useAcademiesQuery = useAcademiesQuery;
export default hooks_useAcademiesQuery;
